import { render, staticRenderFns } from "./CrudDataTable.vue?vue&type=template&id=98869712"
import script from "./CrudDataTable.vue?vue&type=script&lang=js"
export * from "./CrudDataTable.vue?vue&type=script&lang=js"
import style0 from "./CrudDataTable.vue?vue&type=style&index=0&id=98869712&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports